<template>
  <DeleteConfirm
      itemKey="TicketRevenue"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import TicketRevenues from '@/services/ticket-revenues'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return TicketRevenues
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť príjem "' + Item.Revenue.title + '" z ' + this.$moment(Item.Revenue.paidAt).format('DD.MM.YYYY')
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť príjem "' + Item.Revenue.title + '" z ' + this.$moment(Item.Revenue.paidAt).format('DD.MM.YYYY') + '?'
      },
      deleteData() {
        return TicketRevenues
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
